import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core'
import { MatCardModule } from '@angular/material/card'

import { TranslateModule } from '@ngx-translate/core'
import { BehaviorSubject } from 'rxjs'
import { filter, takeUntil } from 'rxjs/operators'

import { UserAccessComponent } from '~/core/components'
import { DestroyDirective } from '~/core/directives'
import { EForecastRisk, EGuardEntityName, EGuardSectionName, EPostReleaseRisk, IForecastDto } from '~/core/models'
import { ForecastNumber, ForecastPercentNumber } from '~/shared/pipes'

@Component({
  selector: 'app-stock-price-predictions-info',
  templateUrl: './stock-price-predictions-info.component.html',
  styleUrl: './stock-price-predictions-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [DestroyDirective],
  imports: [AsyncPipe, MatCardModule, ForecastNumber, TranslateModule, UserAccessComponent, ForecastPercentNumber],
})
export class StockPricePredictionsInfoComponent implements OnInit {
  @Input() guardSectionName: EGuardSectionName | null | undefined
  @Input() set forecast(forecast: IForecastDto | null) {
    if (forecast) {
      this.forecast$.next(forecast)
    }
  }

  EForecastRisk = EForecastRisk
  postReleaseRisk = EForecastRisk.LOW
  EGuardEntityName = EGuardEntityName
  readonly forecast$ = new BehaviorSubject<IForecastDto | null>(null)
  private readonly destroy$ = inject(DestroyDirective).destroy$

  constructor() {}

  ngOnInit(): void {
    this.forecast$
      .pipe(
        filter(f => Boolean(f)),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.setRisk())
  }

  private setRisk(): void {
    if (this.forecast$.value!.postReleaseOvernightMove < EPostReleaseRisk.LOW) {
      this.postReleaseRisk = EForecastRisk.LOW
    } else if (this.forecast$.value!.postReleaseOvernightMove < EPostReleaseRisk.MEDIUM) {
      this.postReleaseRisk = EForecastRisk.MEDIUM
    } else if (this.forecast$.value!.postReleaseOvernightMove < EPostReleaseRisk.HIGH) {
      this.postReleaseRisk = EForecastRisk.HIGH
    } else {
      this.postReleaseRisk = EForecastRisk.VERY_HIGH
    }
  }
}
